const PLYR_VERSION = '3.8.4'
const PLYR_CDN = `https://cdn.plyr.io/${PLYR_VERSION}`

type PlyrConstructor = new (target: HTMLElement | string, options?: object) => {
  destroy: () => void
  source: unknown
  on: (event: string, callback: (...args: unknown[]) => void) => void
  media?: HTMLVideoElement
}

declare global {
  interface Window {
    Plyr?: PlyrConstructor
  }
}

let plyrLoading: Promise<PlyrConstructor> | null = null

/** Official Plyr from plyr.io CDN (CSS + polyfilled JS). */
export function loadPlyrFromCdn(): Promise<PlyrConstructor> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Plyr yalnızca tarayıcıda yüklenir'))
  }
  if (window.Plyr) return Promise.resolve(window.Plyr)
  if (plyrLoading) return plyrLoading

  const loading = new Promise<PlyrConstructor>((resolve, reject) => {
    if (!document.querySelector('link[data-haber-plyr-css]')) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = `${PLYR_CDN}/plyr.css`
      link.dataset.haberPlyrCss = '1'
      document.head.appendChild(link)
    }

    const done = () => {
      if (window.Plyr) resolve(window.Plyr)
      else reject(new Error('Plyr yüklenemedi'))
    }

    const existing = document.querySelector(
      'script[data-haber-plyr-js]',
    ) as HTMLScriptElement | null
    if (existing) {
      if (window.Plyr) {
        done()
        return
      }
      existing.addEventListener('load', done)
      existing.addEventListener('error', () =>
        reject(new Error('Plyr script hatası')),
      )
      return
    }

    const script = document.createElement('script')
    script.src = `${PLYR_CDN}/plyr.polyfilled.js`
    script.async = true
    script.dataset.haberPlyrJs = '1'
    script.onload = done
    script.onerror = () => reject(new Error('Plyr CDN erişilemedi'))
    document.body.appendChild(script)
  })
  loading.finally(() => {
    if (plyrLoading === loading) plyrLoading = null
  })

  plyrLoading = loading
  return loading
}

export const PLYR_CDN_ASSETS = {
  version: PLYR_VERSION,
  iconUrl: `${PLYR_CDN}/plyr.svg`,
  blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
}
